/**
 * Shared layout for legal/marketing pages — Privacy, Terms, Refund, Contact.
 * Renders a consistent hero (title + subtitle) and a typography-styled prose body.
 */
export default function LegalShell({ title, subtitle, children }) {
  return (
    <main
      className="max-w-3xl mx-auto px-6 pt-12 pb-16 relative z-10"
      data-testid="legal-shell"
    >
      <header className="mb-10">
        <h1
          className="font-display italic text-4xl sm:text-5xl text-white leading-[1.05] mb-2"
          data-testid="legal-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-[#9B98AE]">
            {subtitle}
          </p>
        )}
      </header>
      <article className="legal-prose text-[#C9C7D9] text-base leading-[1.7]">
        {children}
      </article>
    </main>
  );
}
